module.exports = (($) => {
    class AjaxLoader {
        static show() {
            $('.loader').show();
            $('body').addClass('ajax-loading');
        }
        static hide() {
            $('.loader').hide();
            $('body').removeClass('ajax-loading');
        }
    }
    $(document).ajaxStart(function() {
        AjaxLoader.show();
    });
    $(document).ajaxStop(function() {
        AjaxLoader.hide();
    });
    return AjaxLoader
})(jQuery)
